import { useEffect } from "react";
import { SelectInput, useStore } from "react-admin";
import Grid from "@mui/material/Grid";
import { useWatch, useFormContext } from "react-hook-form";
import type { CurrentEvent } from "@/containers/events/types";
import {
  formatVenueLabel as formatVenueLabelFromEvent,
  getAsharaVenueChoices,
  getJamanVenueChoices,
  getNamaazVenueChoices,
  venueHelperText,
} from "@/utils/event-venue-utils";

type NiyaazVenueFieldsProps = {
  isAshara: boolean;
};

export const NiyaazVenueFields = ({ isAshara }: NiyaazVenueFieldsProps) => {
  const { setValue } = useFormContext();
  const markaz = useWatch({ name: "markaz" });
  const [currentEvent] = useStore<CurrentEvent | null>("currentEvent", null);

  const helperText = venueHelperText(currentEvent);

  useEffect(() => {
    if (isAshara && markaz) {
      setValue("namaazVenue", markaz, { shouldDirty: false });
    }
  }, [isAshara, markaz, setValue]);

  if (isAshara) {
    return (
      <Grid sx={{ mb: { xs: 2, md: 3 } }} size={{ xs: 12, md: 6 }}>
        <SelectInput
          source="markaz"
          label="Venue"
          helperText={helperText}
          choices={getAsharaVenueChoices(currentEvent)}
          fullWidth
          isRequired
          sx={{ mb: 0 }}
        />
      </Grid>
    );
  }

  return (
    <>
      <Grid sx={{ pr: { xs: 0, md: 1 }, mb: { xs: 2, md: 3 } }} size={{ xs: 12, md: 6 }}>
        <SelectInput
          source="markaz"
          label="Jaman Venue"
          helperText={helperText}
          choices={getJamanVenueChoices(currentEvent)}
          fullWidth
          isRequired
          sx={{ mb: 0 }}
        />
      </Grid>
      <Grid sx={{ mb: { xs: 2, md: 3 } }} size={{ xs: 12, md: 6 }}>
        <SelectInput
          source="namaazVenue"
          label="Namaaz Venue"
          helperText={helperText}
          choices={getNamaazVenueChoices(currentEvent)}
          fullWidth
          isRequired
          sx={{ mb: 0 }}
        />
      </Grid>
    </>
  );
};

export const formatVenueLabel = (code: unknown, currentEvent?: CurrentEvent | null): string =>
  formatVenueLabelFromEvent(code, currentEvent);
